<template>
  <div class="left-box">
    <div class="logo">
      <div class="logo-inner">
        <div class="logo-part part1"></div>
        <div class="logo-part part2"></div>
        <div class="logo-part part3"></div>
        <div class="logo-part part4"></div>
      </div>
      <div class="logo-text">豪超五金</div>
    </div>
    <div class="menu-container" style="overflow-x: hidden; overflow-y: auto; height: 100%">
      <el-menu
          class="sidebar"
          :unique-opened="true"
          :default-active="currentPagePath"
          @open="handleOpen"
          :router="true"
          @close="handleClose"
      >
<!--        <el-menu-item index="/dashboard/welcome">-->
<!--          <i class="fa fa-tachometer"></i>-->
<!--          <span>后台主页</span>-->
<!--        </el-menu-item>-->
        <el-menu-item index="/dashboard/order">
          <i class="fa fa-reorder"></i>
          <span>订单列表</span>
        </el-menu-item>
        <el-submenu index="goods">
          <template slot="title">
            <i class="fa fa-shopping-bag"></i>
            <span>商品管理</span>
          </template>
          <el-menu-item index="/dashboard/goods">
            <i class="fa fa-circle"></i>
            <span>商品列表</span>
          </el-menu-item>
          <el-menu-item index="/dashboard/nature">
            <i class="fa fa-circle"></i>
            <span>商品设置</span>
          </el-menu-item>
        </el-submenu>
        <el-menu-item index="/dashboard/shopcart">
          <i class="fa fa-shopping-cart"></i>
          <span>购物车</span>
        </el-menu-item>
        <el-menu-item index="/dashboard/user">
          <i class="fa fa-users"></i>
          <span>用户列表</span>
        </el-menu-item>
        <el-submenu index="settings">
          <template slot="title">
            <i class="fa fa-wrench"></i>
            <span>店铺设置</span>
          </template>
          <el-menu-item index="/dashboard/settings/showset">
            <i class="fa fa-circle"></i>
            <span>显示设置</span>
          </el-menu-item>
          <el-menu-item index="/dashboard/ad">
            <i class="fa fa-circle"></i>
            <span>广告列表</span>
          </el-menu-item>
          <el-menu-item index="/dashboard/notice">
            <i class="fa fa-circle"></i>
            <span>公告管理</span>
          </el-menu-item>
<!--          <el-menu-item index="/dashboard/freight">-->
<!--            <i class="fa fa-circle"></i>-->
<!--            <span>运费模板</span>-->
<!--          </el-menu-item>-->
<!--          <el-menu-item index="/dashboard/shipper">-->
<!--            <i class="fa fa-circle"></i>-->
<!--            <span>快递设置</span>-->
<!--          </el-menu-item>-->
          <el-menu-item index="/dashboard/admin">
            <i class="fa fa-circle"></i>
            <span>管理员</span>
          </el-menu-item>
        </el-submenu>
        <el-menu-item @click="logout">
          <i class="fa fa-sign-out"></i>
          <span>退出</span>
        </el-menu-item>
      </el-menu>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentPagePath: "/dashboard",
      loginInfo: null,
    };
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    logout() {
      this.$confirm("是否要退出?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        localStorage.clear();
        this.$router.replace({ name: "login" });
      });
    },
    checkLogin() {
      this.axios.get("index/checkLogin").then((response) => {
        console.log(response.data);
        if (response.data.errno === 401) {
          localStorage.clear();
          this.$router.replace({ name: "login" });
        }
      });
    },
  },
  mounted() {
    console.log(this.$route.path);
    this.checkLogin();
    if (!this.loginInfo) {
      this.loginInfo = JSON.parse(
          window.localStorage.getItem("userInfo") || null
      );
    }
  },
};
</script>

<style scoped>
.left-box {
  width: 210px;
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 5;
  height: 100%;
  flex-direction: column;
  background: #304156;
  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s;
}

.left-box:hover {
  width: 230px;
}

.left-box .sidebar {
  width: 100%;
  flex: 1;
  border-radius: 0;
  background: #304156;
}

.left-box .fa {
  margin-right: 10px;
  font-size: 18px;
  color: #bfcbd9;
  transition: color 0.3s;
}

.left-box .el-menu-item,
.left-box .el-submenu__title {
  color: #bfcbd9 !important;
  transition: color 0.3s;
}

.left-box .el-menu-item:hover,
.left-box .el-submenu__title:hover {
  background-color: #263445 !important;
  color: #f4f4f5 !important;
}

.left-box .el-menu-item.is-active,
.left-box .el-submenu__title.is-active {
  background-color: #263445 !important;
  color: #f4f4f5 !important;
}

.left-box .el-submenu .el-menu-item {
  background: #1f2d3d !important;
}

.left-box .el-submenu .el-menu-item:hover,
.left-box .el-submenu .el-menu-item.is-active {
  background: #17212b !important;
  color: #f4f4f5 !important;
}

.left-box .el-submenu .el-menu-item .fa {
  margin-right: 10px;
  font-size: 10px;
  color: #bfcbd9;
}

/* 覆盖默认的 el-submenu__title 样式 */
.left-box /deep/ .el-submenu__title {
  font-size: 14px;
  color: #bfcbd9 !important;
  padding: 0 20px;
  cursor: pointer;
  transition: border-color .3s, background-color .3s, color .3s;
  box-sizing: border-box;
}

.left-box /deep/ .el-submenu__title:hover {
  background-color: #263445 !important;
  color: #f4f4f5 !important;
}

.left-box /deep/ .el-submenu__title.is-active {
  background-color: #001528 !important;
  color: #f4f4f5 !important;
}

.left-box .logo {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 150px; /* 调整高度以容纳文本 */
  width: 100%;
  border-bottom: solid 1px #263445;
}

.logo-inner {
  display: flex;
  flex-wrap: wrap;
  width: 60px;
  height: 60px;
  position: relative;
  border-radius: 50%;
  background: radial-gradient(circle at center, #0077b6, #00aaff, #48cae4, #90e0ef);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  animation: logoRotate 10s linear infinite;
}

.logo-part {
  width: 50%;
  height: 50%;
}

.part1 {
  background: rgba(0, 119, 182, 0.7);
}

.part2 {
  background: rgba(0, 170, 255, 0.7);
}

.part3 {
  background: rgba(72, 202, 228, 0.7);
}

.part4 {
  background: rgba(144, 224, 239, 0.7);
}

.logo-text {
  margin-top: 12px;
  font-size: 15px;
  color: #f4f4f5;
  text-align: center;
}

@keyframes logoRotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
